import { Feature } from '@reliance/types/enums/Feature';
import { Facility } from '@reliance/types/models/Facility';
import React from 'react';
import Badge from 'react-bootstrap/Badge';
import Card from 'react-bootstrap/Card';

type FeaturesProps = {
  facility: Facility;
};

const Features: React.FC<FeaturesProps> = (props) => {
  return (
    <Card>
      <Card.Header>Features at Facility</Card.Header>
      <Card.Body>
        {Object.keys(Feature).sort().map((feature) =>
          <div style={{ padding: 2, display: 'flex', alignItems: 'center', fontSize: '.9em' }} key={feature}>
            <Badge
              pill
              bg={props.facility.features.indexOf(Feature[feature]) > -1 ? 'primary' : 'secondary'}>
              {props.facility.features.indexOf(Feature[feature]) > -1 ?
                <i className="fas fa-check" /> :
                <i className="fas fa-x" />
              }
            </Badge>&nbsp;
            {Feature[feature]}
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default Features;
